import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, forwardRef, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl } from '@angular/forms';
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true },
    // { provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckboxComponent), multi: true },
  ]
})
export class CheckboxComponent implements OnInit, OnChanges, ControlValueAccessor {
  propagateChange: any = () => {};
  setDisabledState: any = () => {};
  @Input() inputId: string;
  @Input() inverted: boolean = false;
  @Input() isRedesign: boolean = false;
  @Input() text: string;
  @Input() disabledActiveText: boolean = false;

  @Input() parentFormGroup: FormGroup;
  @Input() formControl: FormControl;

  private _val: boolean;
  // Use this to pass in a custom validator function
  @Input() externalValidation: boolean = undefined;

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    this.val = !this.val;
  }

  ngOnChanges(changes: SimpleChanges) {}

  // Create a valididation function
  get val() {
    return this._val;
  }

  set val(val) {
    this._val = val;
    this.propagateChange(this._val);
  }

  // Called when form is initialized, with form model's initial value
  writeValue(value: any) {
    if (value !== undefined) this.val = value;
  }

  // Access to a function that informs the outside world about changes
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  // Callback whenever a form input is touched (ex: on blur, fires touch event)
  registerOnTouched(event) {
  }

}
